import * as tslib_1 from "tslib";
import { Container } from './container';
import { ToolHelper } from '../utility/index';
var ItemContainer = /** @class */ (function (_super) {
    tslib_1.__extends(ItemContainer, _super);
    function ItemContainer(param) {
        var _this = _super.call(this, param) || this;
        var obj;
        if (typeof param === 'string') {
            obj = JSON.parse(param);
        }
        else {
            obj = param;
        }
        if (!obj) {
            return _this;
        }
        _this.contents = [];
        var keys = 'contents';
        Object.keys(obj).forEach(function (key) {
            if (keys.includes(key)) {
                obj[key].forEach(function (item) {
                    var domObj = ToolHelper.createObjectByType(item.type);
                    if (domObj) {
                        _this.contents.push(new domObj(item));
                    }
                });
            }
        });
        return _this;
    }
    ItemContainer.prototype.toJSON = function () {
        var result = [];
        if (this.contents && this.contents.length) {
            this.contents.forEach(function (item) {
                result.push(item.toJSON());
            });
        }
        return Object.assign({}, _super.prototype.toJSON.call(this), { "contents": result, "type": "ItemContainer" });
    };
    ItemContainer.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return ItemContainer;
}(Container));
export { ItemContainer };
//# sourceMappingURL=item_container.js.map